var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-satisfaction flex-center-wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "subscription-satisfaction__iconbox flex-center-wrapper",
        },
        [
          _c("rt-picture", {
            attrs: { src: "/assets/app/class/icon-guarantee.svg" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "subscription-satisfaction__content" }, [
      _c("h2", { staticClass: "subscription-satisfaction__content-name" }, [
        _vm._v("Satisfaction guaranteed."),
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "subscription-satisfaction__content-description" },
        [
          _vm._v(
            "\n      You can cancel at anytime with the 30-Day trial period.\n    "
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }